import {
  BUILDING_LIST_API,
  CHATS_LIST_API,
  DOCUMENT_STAPLINGS_LIST_API,
  FLAT_LIST_API,
  NEWSBOARD_LIST_API,
  REQUEST_LIST_API,
  REQUEST_LIST_COUNT_API,
  TASKS_LIST_API,
} from '../../constants/api'
import { PAGE_DEFAULT_VALUE } from '../../constants/route'
import { postApi } from '../../utils/api'

import {
  BIRDVIEW_ACTIVITIES_ORDERING,
  BIRDVIEW_BUILDINGS_ORDERING,
  BIRDVIEW_CHATS_ORDERING,
  BIRDVIEW_DOC_FLOWS_ORDERING,
  BIRDVIEW_FLATS_ORDERING,
  BIRDVIEW_POSTS_ORDERING,
  BIRDVIEW_REQUESTS_ORDERING,
  BIRDVIEW_SECTION_ITEMS_LIMIT,
} from './DashboardBirdview.constants.api'

export function getBirdviewRequestsCount(filters) {
  return postApi({ data: { filters }, endpoint: REQUEST_LIST_COUNT_API })
}

export function getBirdviewRequests(filters) {
  return postApi({
    data: {
      filters,
      ordering: BIRDVIEW_REQUESTS_ORDERING,
      page: PAGE_DEFAULT_VALUE,
      size: BIRDVIEW_SECTION_ITEMS_LIMIT,
    },
    endpoint: REQUEST_LIST_API,
  })
}

export function getBirdviewBuildings(filters) {
  return postApi({
    data: {
      filters,
      ordering: BIRDVIEW_BUILDINGS_ORDERING,
      page: PAGE_DEFAULT_VALUE,
      size: BIRDVIEW_SECTION_ITEMS_LIMIT,
    },
    endpoint: BUILDING_LIST_API,
  })
}

export function getBirdviewDocFlows(filters) {
  return postApi({
    data: {
      filters,
      ordering: BIRDVIEW_DOC_FLOWS_ORDERING,
      page: PAGE_DEFAULT_VALUE,
      size: BIRDVIEW_SECTION_ITEMS_LIMIT,
    },
    endpoint: DOCUMENT_STAPLINGS_LIST_API,
  })
}

export function getBirdviewActivities(filters) {
  return postApi({
    data: {
      filters,
      ordering: BIRDVIEW_ACTIVITIES_ORDERING,
      page: PAGE_DEFAULT_VALUE,
      size: BIRDVIEW_SECTION_ITEMS_LIMIT,
    },
    endpoint: TASKS_LIST_API,
  })
}

export function getBirdviewPosts(filters) {
  return postApi({
    data: {
      filters,
      ordering: BIRDVIEW_POSTS_ORDERING,
      page: PAGE_DEFAULT_VALUE,
      size: BIRDVIEW_SECTION_ITEMS_LIMIT,
    },
    endpoint: NEWSBOARD_LIST_API,
  })
}

export function getBirdviewChats(filters) {
  return postApi({
    data: {
      filters,
      ordering: BIRDVIEW_CHATS_ORDERING,
      page: PAGE_DEFAULT_VALUE,
      size: BIRDVIEW_SECTION_ITEMS_LIMIT,
    },
    endpoint: CHATS_LIST_API,
  })
}

export function getBirdviewFlats(filters) {
  return postApi({
    data: {
      filters,
      ordering: BIRDVIEW_FLATS_ORDERING,
      page: PAGE_DEFAULT_VALUE,
      size: BIRDVIEW_SECTION_ITEMS_LIMIT,
    },
    endpoint: FLAT_LIST_API,
  })
}
